import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';
import { joiSchemaValidators, validateDataWithJoi } from '../helpers/validators';

enum RequestIds {
  GET_DATA_GRID = 'GET_DATA_GRID',
}

export const dataGridsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDataGridById: builder.query({
      query: ({ dataGridId }) => ({
        url: `/data-grids/${dataGridId}`,
        method: 'GET',
      }),
      transformResponse: (result: any) =>
        validateDataWithJoi({
          actionName: 'Service:: getDataGridById',
          data: result.data,
          validateJsonSchema: false,
          joiSchema: joiSchemaValidators.DATA_GRID_FROM_API,
        }),
      providesTags: () => [{ type: ServiceTypes.DATA_GRIDS, id: RequestIds.GET_DATA_GRID }],
    }),
    updateDataGrid: builder.mutation({
      query: ({ dataGridId, data }) => ({
        url: `/data-grids/${dataGridId}`,
        method: 'PATCH',
        body: { data: data },
      }),
      invalidatesTags: () => [
        {
          type: ServiceTypes.DATA_GRIDS,
          id: RequestIds.GET_DATA_GRID,
        },
        { type: ServiceTypes.PROJECTS, id: 'GET_PROJECT' },
      ],
    }),
  }),
});

export const { useGetDataGridByIdQuery, useUpdateDataGridMutation } = dataGridsService;
